<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Nandi Mhlongo is a realist who aims to capture the world behind its sunshine and butterflies’ façade. Having grown up in a society where mental health was never prioritised. Herself a sufferer, she has seen adults and children suffer in silence with no one to talk to or get help from. This is her way of bringing awareness and hopefully the needed assistance to the mental health community.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4b9b96dd